import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import { getGetUserGroupsQueryKey } from "api/generated/user-groups/user-groups";
import {
    getGetUsersUserIdControlsQueryKey,
    usePatchUsersUserIdUserGroups,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdateUserGroupRightsForUserMutation() {
    return usePatchUsersUserIdUserGroups({
        mutation: {
            onSuccess: async (_response, { userId }) => {
                emitNotification("success", t("UserManagement_GroupUpdated"));
                await Promise.all([
                    // Prefix match invalidates the params-keyed groups query too.
                    queryClient.invalidateQueries({
                        queryKey: getGetUserGroupsQueryKey(),
                    }),
                    queryClient.invalidateQueries({
                        queryKey: getGetUsersUserIdControlsQueryKey(userId, {
                            linked_from_groups: true,
                        }),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
